import { defineComponent as C, useSlots as w, computed as s, useAttrs as A, openBlock as a, createElementBlock as i, normalizeClass as N, createBlock as T, resolveDynamicComponent as _, mergeProps as R, withCtx as S, renderSlot as V, toDisplayString as m, createCommentVNode as f, createVNode as D, unref as r } from "vue";
import { RevButtonBase as d } from "@ds/components/ButtonBase";
import { RevButtonIcon as I } from "@ds/components/ButtonIcon";
import { usePropsValidation as P } from "../../composables/usePropsValidation.js";
import $ from "../../icons/generated/IconCross.vue2.js";
import { useI18n as j } from "@ds/plugin";
import z from "../../translations/generic.translations.js";
import { tw as e } from "../../utils/tailwind.js";
const E = {
  key: 0,
  class: "body-2 pr-4"
}, q = {
  key: 1,
  class: "group-focus-visible-outline-default-hi rounded-sm body-2-link"
}, Q = /* @__PURE__ */ C({
  name: "RevBanner",
  inheritAttrs: !1,
  __name: "Banner",
  props: {
    closeAlternativeText: {},
    cta: {},
    label: {},
    to: {}
  },
  emits: ["close"],
  setup(n, { emit: p }) {
    const t = n, v = p, h = w();
    P({
      "please, provide either props.label or a default slot": () => !h.default && !t.label
    });
    const b = s(() => {
      const o = e`bg-static-info-hi flex w-full items-center justify-center`, u = [
        e`cursor-pointer`,
        e`focus-within:bg-static-info-hi-hover hover:bg-static-info-hi-hover`,
        e`focus-within:no-underline hover:no-underline`,
        e`motion-safe:transition motion-safe:duration-200 motion-safe:ease-in`
      ];
      return t.to ? [o, u] : o;
    }), g = s(() => [
      e`text-action-default-hi group flex-1 py-16 pl-24 text-left leading-none no-underline md:p-16 md:text-center`,
      t.cta && e`outline-none`,
      !t.cta && e`focus-visible-outline-default-hi`
    ]), l = s(() => t.to ? d : "div"), c = A(), x = s(() => l.value === d ? {
      ...c,
      to: t.to
    } : c);
    function B(o) {
      v("close", o);
    }
    const k = j(), y = t.closeAlternativeText || k(z.buttonClose);
    return (o, u) => (a(), i("aside", {
      class: N(b.value)
    }, [
      (a(), T(_(l.value), R({ class: g.value }, x.value), {
        default: S(() => [
          V(o.$slots, "default"),
          n.label ? (a(), i("span", E, m(n.label), 1)) : f("", !0),
          n.cta ? (a(), i("span", q, m(n.cta), 1)) : f("", !0)
        ]),
        _: 3
      }, 16, ["class"])),
      D(r(I), {
        "aria-label": r(y),
        class: "mr-8",
        icon: r($),
        variant: "ghost",
        onClick: B
      }, null, 8, ["aria-label", "icon"])
    ], 2));
  }
});
export {
  Q as default
};
